"use client";

import { c as _c } from "react/compiler-runtime";
import { sanitizeStoredAmounts, sanitizeStoredDropIds } from "@/hooks/memesQuickVote.helpers";
import { readStoredNumberArray, readStoredStringArray, useStoredNumberArray, useStoredStringArray, writeStoredNumberArray, writeStoredStringArray } from "@/hooks/memesQuickVote.storageStore";
import { useCallback } from "react";
const SKIPPED_STORAGE_PREFIX = "memesQuickVoteSkipped";
const AMOUNTS_STORAGE_PREFIX = "memesQuickVoteAmounts";
type UseMemesQuickVoteStorageOptions = {
  readonly contextProfile: string | null | undefined;
  readonly memesWaveId: string | null | undefined;
};
type UseMemesQuickVoteStorageResult = {
  readonly skippedDropIds: string[];
  readonly recentAmountsByRecency: number[];
  readonly setAndPersistRecentAmounts: (updater: (current: number[]) => number[]) => void;
  readonly setAndPersistSkippedDropIds: (updater: (current: string[]) => string[]) => void;
};
const getStorageKey = (prefix: string, memesWaveId: string | null | undefined, contextProfile: string | null | undefined): string | null => {
  if (!memesWaveId || !contextProfile) {
    return null;
  }
  return `${prefix}:${memesWaveId}:${contextProfile}`;
};
const areNumberArraysEqual = (left: readonly number[], right: readonly number[]): boolean => left.length === right.length && left.every((value, index) => value === right[index]);
const areStringArraysEqual = (left: readonly string[], right: readonly string[]): boolean => left.length === right.length && left.every((value, index) => value === right[index]);
export const useMemesQuickVoteStorage = t0 => {
  const $ = _c(15);
  const {
    contextProfile,
    memesWaveId
  } = t0;
  let t1;
  if ($[0] !== contextProfile || $[1] !== memesWaveId) {
    t1 = getStorageKey(SKIPPED_STORAGE_PREFIX, memesWaveId, contextProfile);
    $[0] = contextProfile;
    $[1] = memesWaveId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const skippedStorageKey = t1;
  let t2;
  if ($[3] !== contextProfile || $[4] !== memesWaveId) {
    t2 = getStorageKey(AMOUNTS_STORAGE_PREFIX, memesWaveId, contextProfile);
    $[3] = contextProfile;
    $[4] = memesWaveId;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const amountsStorageKey = t2;
  const skippedDropIds = useStoredStringArray(skippedStorageKey, sanitizeStoredDropIds);
  const recentAmountsByRecency = useStoredNumberArray(amountsStorageKey, sanitizeStoredAmounts);
  let t3;
  if ($[6] !== amountsStorageKey) {
    t3 = updater => {
      const current = readStoredNumberArray(amountsStorageKey, sanitizeStoredAmounts);
      const next = sanitizeStoredAmounts(updater([...current]));
      if (areNumberArraysEqual(current, next)) {
        return;
      }
      writeStoredNumberArray(amountsStorageKey, next);
    };
    $[6] = amountsStorageKey;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const setAndPersistRecentAmounts = t3;
  let t4;
  if ($[8] !== skippedStorageKey) {
    t4 = updater_0 => {
      const current_0 = readStoredStringArray(skippedStorageKey, sanitizeStoredDropIds);
      const next_0 = sanitizeStoredDropIds(updater_0([...current_0]));
      if (areStringArraysEqual(current_0, next_0)) {
        return;
      }
      writeStoredStringArray(skippedStorageKey, next_0);
    };
    $[8] = skippedStorageKey;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const setAndPersistSkippedDropIds = t4;
  let t5;
  if ($[10] !== recentAmountsByRecency || $[11] !== setAndPersistRecentAmounts || $[12] !== setAndPersistSkippedDropIds || $[13] !== skippedDropIds) {
    t5 = {
      skippedDropIds,
      recentAmountsByRecency,
      setAndPersistRecentAmounts,
      setAndPersistSkippedDropIds
    };
    $[10] = recentAmountsByRecency;
    $[11] = setAndPersistRecentAmounts;
    $[12] = setAndPersistSkippedDropIds;
    $[13] = skippedDropIds;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};